<template>
    <div>
        <div class="form-actions">
            <b-button variant="primary" @click="editor.show = true">{{ $t('edit') }}</b-button>
        </div>

        <b-modal size="lg" title="Edit mutations" v-model="editor.show" @ok="save">
            <CodeEditor
                v-model="mutators.get"
                :placeholder="this.$t('fieldValue')"
                editor_description="When field is initialized this mutator will be applied."
                :description="this.$t('mutatorApplied')"
                :label="this.$t('get')"
                :label-cols="2"
                :horizontal="true"
                :libs="libs"
                :vars="vars"
            />

            <CodeEditor
                v-model="mutators.set"
                :placeholder="this.$t('fieldValue')"
                editor_description="When this field is set function will be applied."
                :description=" this.$t('functionApplied')"
                :label="this.$t('set')"
                :label-cols="2"
                :horizontal="true"
                :libs="libs"
                :vars="vars"
            />
        </b-modal>
    </div>

</template>

<script>
import safeEval from "safe-eval"
import Input from "@/components/form/Input"
import CodeEditor from "@/components/form/Editor/Code"
import _ from "lodash"

export default {
    name: "Mutators",
    components: {
        InputField: Input,
        CodeEditor
    },
    props: {
        value: {
            type: Object
        }
    },

    data: function() {
        return {
            vars: [
                {
                    name: "value",
                    usage: `Current value of field when mutator is triggered.`
                },
                {
                    name: "parent",
                    usage: `Current value of parent object`
                }
            ],
            mutators: this.value,
            editor: {
                show: false,
                options: {
                        tabSize: 4,
                        lineNumbers: true,
                        line: true,
                        autoRefresh: true,
                        foldGutter: true,
                        styleSelectedText: true,
                        mode: 'text/javascript',
                        matchBrackets: true,
                        showCursorWhenSelecting: true
                    }
            }
        }
    },

    computed: {
        docsUrl() {
            return this.$env.get('DOCS_URL')
        },

        libs() {
            return [
                {
                    name: "Lodash",
                    varName: "_",
                    docs: "https://lodash.com/"
                },
                {
                    name: "moment",
                    varName: "moment",
                    docs: "https://momentjs.com"
                },
                {
                    name: "context",
                    varName: "context",
                    docs: this.docsUrl + "/docs#libs-context"
                }
            ]
        }
    },

    methods: {
        save() {
            this.$emit('input', this.mutators)
        },

        evalGet() {
            let cont = safeEval("(function() { try { "+this.mutators.get+" } catch (err) { self.$bvModal.msgBoxOk(err.message) } }());", {
                value: this.context.value,
                self: this,
                _: _
            })

            if (cont !== undefined) {
                this.$bvModal.msgBoxOk(cont)
            }
        },

        evalSet() {
           let cont = safeEval("(function() { try { "+this.mutators.set+" } catch (err) { self.$bvModal.msgBoxOk(err.message) } }());", {
                value: this.context.value,
                self: this,
                _: _
            })

            if (cont !== undefined) {
                this.$bvModal.msgBoxOk(cont)
            }
        }
    }
}
</script>
